import React from 'react';
import { Container, Text } from './PerPageSelect.styles';
import Select from '../../utils/Select/Select';

const OPTIONS = [
  { label: 10, value: 10 },
  { label: 25, value: 25 },
  { label: 50, value: 50 },
  { label: 100, value: 100 },
];

const PerPageSelect = ({ perPage, setPerPage }) => {
  return (
    <Container>
      <Text>Result per page</Text>
      <Select
        hideError
        options={OPTIONS}
        selectedOption={OPTIONS.find(o => o.value === perPage)}
        handleChange={({ value }) => setPerPage(value)}
        isSearchable={false}
        placeholder=""
        stylesOverride={{
          control: base => ({
            ...base,
            borderWidth: '0',
            boxShadow: 'none',
            minHeight: 'unset',
          }),
          dropdownIndicator: baseStyles => ({
            ...baseStyles,
            height: 'unset',
          }),
          valueContainer: baseStyles => ({
            ...baseStyles,
            padding: 'unset',
            fontSize: '1.4rem',
          }),
          singleValue: baseStyles => ({
            ...baseStyles,
            fontSize: '1.4rem',
          }),
        }}
      />
    </Container>
  );
};

export default PerPageSelect;
